export default "__VITE_ASSET__c24cbc10__"